import * as React from 'react'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Title, Button } from '../../elements'

interface Props {
  title: React.ReactNode
  icon?: any
  type?: ModalType
  text?: React.ReactNode
  className?: string
  dataQa?: string
  content?: React.ReactNode
  stack?: number
  onConfirm: () => any
  onCancel?: () => any
  confirmButtonLabel: React.ReactNode
  cancelButtonLabel: React.ReactNode
}

export type ModalType = 'action' | 'success' | 'danger' | 'error' | 'warning'

export const Modal = ({
  className,
  dataQa,
  icon,
  title,
  type,
  text,
  content,
  stack,
  onConfirm,
  onCancel,
  confirmButtonLabel,
  cancelButtonLabel
}: Props) => (
  <div
    style={{ zIndex: stack }}
    className={classNames(
      'modal-wrapper modal is-active',
      {
        [`is-${type}`]: type
      },
      className
    )}
    data-qa={dataQa}
  >
    <div className="modal-background" />
    <div className="modal-container" data-qa="modal">
      <div className="modal-content">
        <div className="modal-icon">
          {icon && <FontAwesomeIcon icon={icon} />}
        </div>
        {title && (
          <Title
            size={2}
            dataQa="title"
            className="modal-title has-text-centered"
          >
            {title}
          </Title>
        )}
        {text && (
          <div className="text has-text-centered" data-qa="text">
            {text}
          </div>
        )}
        {content}
      </div>
      <div className="modal-buttons">
        {onCancel && (
          <Button plain={true} onClick={onCancel} dataQa="modal-cancelBtn">
            {cancelButtonLabel}
          </Button>
        )}
        <Button plain={true} onClick={onConfirm} dataQa="modal-okBtn">
          {confirmButtonLabel}
        </Button>
      </div>
    </div>
  </div>
)
